import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginPageSharedService {
  public isSidebarActive: boolean;
  public loginUserName: string;
  public loginPassword: string;
}
